import { pxToRem, Logotype } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { SIDEBAR_PADDING, LOGOTYPE_PADDING } from '../config';
export const SidebarMenuHeaderContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: ${SIDEBAR_PADDING};
  padding: ${SIDEBAR_PADDING};
`;
export const StyledLogotype = styled(Logotype) `
  width: auto;
  height: ${pxToRem(16)};
  padding-left: ${LOGOTYPE_PADDING};
`;
